import * as types from "./ActionTypes";
import * as accrualAPI from "../../apis/revshare/AccrualApi";
import { addActiveApiCall } from "./ActiveApiActions";

export const loadCalculableQuartersSuccess = (quarters) => {
  return { type: types.LOAD_CALCULABLE_QUARTERS, quarters };
};

export const loadAccrualCalculatorHistorySuccess = (history) => {
  return { type: types.LOAD_ACCRUAL_CALCULATOR_HISTORY, history };
};

export const calculateAccruedRevShareForQuarterSuccess = () => {
  return { type: types.RUN_ACCRUAL_CALCULATOR };
};

export const loadCalculableQuarters = () => {
  return (dispatch) => {
    dispatch(addActiveApiCall(types.LOAD_CALCULABLE_QUARTERS));
    return accrualAPI
      .getCalculableQuarters()
      .then((quarters) => {
        dispatch(loadCalculableQuartersSuccess(quarters));
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const loadAccrualCalculatorHistory = () => {
  return (dispatch) => {
    dispatch(addActiveApiCall(types.LOAD_ACCRUAL_CALCULATOR_HISTORY));
    return accrualAPI
      .getAccrualCalculatorRunHistory()
      .then((history) => dispatch(loadAccrualCalculatorHistorySuccess(history)))
      .catch((error) => {
        throw error;
      });
  };
};

export const calculateAccruedRevShareForQuarter = (quarter, year) => {
  return (dispatch) => {
    dispatch(addActiveApiCall(types.RUN_ACCRUAL_CALCULATOR));
    return accrualAPI
      .calculateAccruedRevShareForQuarter(quarter, year)
      .then(() => {
        loadAccrualCalculatorHistory();
        dispatch(calculateAccruedRevShareForQuarterSuccess());
      })
      .catch((error) => {
        throw error;
      });
  };
};
